import { DeleteOutlined, ReloadOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space, Switch } from 'antd';
import React from 'react';
import { TableColumnInterface } from 'type/tableType';
import { VideoSourceInterface } from '../type/videoSourceType';

interface VideoSourceColumnsProps {
  onClickTitleButton: (id: number) => void;
  onClickSettingButton: (id: number) => void;
  onClickDeleteButton: (id: number) => void;
  onClickReloadButton: (id: number) => void;
}

export const getVideoSourceColumns = ({
  onClickTitleButton,
  onClickSettingButton,
  onClickDeleteButton,
  onClickReloadButton,
}: VideoSourceColumnsProps): TableColumnInterface<VideoSourceInterface>[] => {
  return [
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: VideoSourceInterface) => (
        <div className="video-source-title" onClick={() => onClickTitleButton(record.id || 0)}>
          {text}
        </div>
      ),
    },
    {
      title: 'category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'feed_format',
      dataIndex: 'feed_format',
      key: 'feed_format',
      render: (text: string) => text || 'auto',
    },
    {
      title: 'mrss_url',
      dataIndex: 'mrss_url',
      key: 'mrss_url',
    },
    {
      title: 'created',
      dataIndex: 'created',
      key: 'created',
    },
    {
      title: 'last_updated',
      dataIndex: 'last_updated',
      key: 'last_updated',
    },
    {
      title: 'auto-activate-videos',
      dataIndex: 'auto_activate_videos',
      key: 'auto_activate_videos',
      render: (_: string, record: VideoSourceInterface) => (
        <Switch
          checked={record.auto_activate_videos}
          checkedChildren="On"
          unCheckedChildren="Off"
          disabled
        />
      ),
    },
    {
      title: 'auto-add-videos',
      dataIndex: 'auto_add_videos',
      key: 'auto_add_videos',
      render: (_: string, record: VideoSourceInterface) => (
        <Switch
          checked={record.auto_add_videos}
          checkedChildren="On"
          unCheckedChildren="Off"
          disabled
        />
      ),
    },
    {
      title: 'ACTIONS',
      key: 'actions',
      dataIndex: 'actions',
      render: (_text: string, record: VideoSourceInterface) => (
        <Space>
          <Button
            icon={
              <Popconfirm
                title="Are you sure you want to reload?"
                okText="Confirm"
                cancelText="Cancel"
                onConfirm={() => onClickReloadButton(record.id || 0)}
              >
                <ReloadOutlined />
              </Popconfirm>
            }
            className="action-btn play-btn"
          />
          <Button
            icon={<SettingOutlined />}
            onClick={() => onClickSettingButton(record.id || 1)}
            className="action-btn"
          />
          <Button
            icon={<DeleteOutlined />}
            className="action-btn delete-btn"
            onClick={() => onClickDeleteButton(record.id || 0)}
          />
        </Space>
      ),
    },
  ];
};
